import React from "react";
import { Container } from "react-bootstrap";
import "./rewardmanagement.css";

const ReputationManagement = () => {
  return (
    <Container className="py-5 reward-management">
      <h2 className="section-title">Reputation Management System</h2>
      <p className="lead">
        We provide the reputation management solution that enables hotels to
        protect, monitor, and enhance their public image with clarity and
        confidence. That helps transform guest feedback into proactive service
        improvements and brand trust—where every voice is heard and every
        impression matters.
      </p>

      <h4 className="subheading">🔍 Key Features:</h4>
      <ul className="feature-list">
        <li>
          <strong>✅ Unified Review Monitoring:</strong> Track guest feedback
          from OTAs, social platforms, and internal surveys in one streamlined
          dashboard—ensuring nothing slips through the cracks.
        </li>
        <li>
          <strong>✅ Feedback Trend Analysis:</strong> Understand shifts in
          guest sentiment through structured keyword and tone monitoring.
          Pinpoint service pain points and emerging praise in seconds.
        </li>
        <li>
          <strong>✅ Custom Response Library:</strong> Respond confidently with
          templated, brand-aligned messaging that can be adapted by tone,
          language, and channel.
        </li>
        <li>
          <strong>✅ Automated Post-Stay Outreach:</strong> Build review volume
          and trust by sending review invitations post-checkout—personalized to
          each guest journey.
        </li>
        <li>
          <strong>✅ Reputation Insights Center:</strong> Access visual trend
          reports, benchmark comparisons, and property-level scorecards to
          inform leadership decisions and elevate operational standards.
        </li>
      </ul>

      <h4 className="subheading mt-5">💼 Strategic Benefits:</h4>
      <ul className="feature-list">
        <li>
          <strong>Enhance Brand Trust</strong> with consistent, thoughtful, and
          visible responses to guest feedback.
        </li>
        <li>
          <strong>Spot Service Gaps Early</strong> by turning qualitative
          insights into operational improvements.
        </li>
        <li>
          <strong>Support Staff Development</strong> with team-level reputation
          metrics and accountability tracking.
        </li>
        <li>
          <strong>Maintain Competitive Edge</strong> by benchmarking performance
          across properties and regions.
        </li>
      </ul>
    </Container>
  );
};

export default ReputationManagement;
